<template>
    <div class="page-table haberTanim scrollable mainDiv" id="affix-container">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.bayi.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.bayi.tanimlama.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.bayi.tanimlama.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="bayiForm" :rules="rulesBayilar" ref="bayiForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.bayi.tanimlama.bayiAdi")'
                                              prop="bayiAdi">:
                                    <el-input
                                            v-model="bayiForm.bayiAdi"
                                            :placeholder='$t("src.views.apps.bayi.tanimlama.bayiAdiPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.bayi.tanimlama.adres")'
                                              prop="adres">:
                                    <el-input
                                            v-model="bayiForm.adres" type="textarea"
                                            :placeholder='$t("src.views.apps.bayi.tanimlama.adresPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                <el-form-item :label='$t("src.views.apps.bayi.tanimlama.harita")'
                                              prop="harita">:
                                    <el-input
                                            type="textarea"
                                            v-model="bayiForm.harita"
                                            :placeholder='$t("src.views.apps.bayi.tanimlama.haritaPlace")'></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                        <el-collapse-item title="Resim Ayarları" name="7">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.bayi.tanimlama.resim")'
                                                  prop="resim">:
                                        <el-upload
                                                class="resimler"
                                                action=""
                                                list-type="picture-card"
                                                multiple
                                                :file-list="imageListMain"
                                                :auto-upload="false"
                                                accept=".jpg,.jpeg,.png"
                                                :on-change="imageUpload"
                                                :on-preview="firstImage"
                                                :on-remove="imageRemove">
                                            <i slot="default" class="el-icon-plus"></i>
                                        </el-upload>
                                        <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                   v-on:click="serverImageList"
                                                   @click="dialogImgServerVisible = true; " size="mini">
                                            Sunucudan
                                            Seç
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.bayi.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select
                                                v-model="bayiForm.durum"
                                                style="width: 100%">
                                            <el-option value="0" label="Taslak">Taslak</el-option>
                                            <el-option value="1" label="Yayınla">Yayınla</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini" v-on:click="bayiTanimlama('bayiForm',bayiForm.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="bayiForm.durum === '1'">{{$t('src.views.apps.bayi.tanimlama.bayiEkle')}}</label>
                                    <label v-else>Taslak Olarak Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.yonetici.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('bayiForm')">
                                            {{$t('src.views.apps.yonetici.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.yonetici.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.yonetici.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip :content="$t('src.views.apps.bayi.tanimlama.copKutusu')" :open-delay="500"
                                            placement="bottom">
                                    <el-button class="cop" v-on:click="bayiTanimlama('bayiForm','0')" type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.bayi.tanimlama.telefon")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="telefon">
                                        <el-input
                                                v-model="bayiForm.telefon" v-mask="'+90(###)### ## ##'"
                                                placeholder="+90(555)555 55 55"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item :title='$t("src.views.apps.bayi.tanimlama.webSite")' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="webSite">
                                        <el-input
                                                v-model="bayiForm.webSite"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        accept=".jpg,.jpeg,.png"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    let $ = JQuery;
    import draggable from 'vuedraggable'

    import bayiService from '../../../WSProvider/BayiService'
    import sayfaService from '../../../WSProvider/SayfaService'
    import status from '../../../status'

    let base64 = require('base64_js');
    let userDataArtdoor = "";

    const message = [
        "vue.draggable",
        "draggable",
        "component",
        "for",
        "vue.js 2.0",
        "based",
        "on",
        "Sortablejs"
    ];
    export default {
        name: "BayiTanimlama",
        display: "Transitions",
        order: 7,
        components: {
            draggable
        },
        data() {
            return {
                cards: [{
                    title: '<el-button>deneme</el-button>'
                }],
                list: message.map((name, index) => {
                    return {name, order: index + 1};
                }),
                drag: false,


                drawerResimKonum: false,
                drawerMenuKonum: false,
                drawerGaleriKonum: false,
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListServer: [],
                fileListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr',
                },
                linkVisible: false,

                //Tree
                visibleUstBayi: false,
                treeList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                // Form
                btnResim: "Seç",
                btnMenu: "Seç",
                btnGaleri: "Seç",
                linkChange: true,
                seoicerikChange: true,
                seoicerikIngChange: true,
                VisibleA: false,
                duzenleBtnVisible: true,
                visibleSil: false,
                imageListMain: [],
                fileListMain: [],
                bayiForm: {
                    bayiAdi: "",
                    adres: "",
                    harita: "",
                    resim: [],
                    telefon: '',
                    webSite: '',
                    durum: "1",
                },
                rulesBayilar: {
                    bayiAdi: [{
                        required: true,
                        message: "Lütfen Bayi Adı Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        methods: {
            // inputStyle(val, form) {
            //     var splitStr = val.toLowerCase().split(' ');
            //     for (var i = 0; i < splitStr.length; i++) {
            //         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            //     }
            //     this.bayiForm[form] = splitStr.join(' ');
            // },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                status.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(13) + '-' + file.name);
                } else {
                    fileList.pop();
                    status.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverImageList() {
                var dizi = [];
                bayiService.resimList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: bayiService.imageUrlKucuk + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },

            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name.slice(file.name.indexOf("-") + 1),
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    status.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name.slice(file.name.indexOf("-") + 1),
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        status.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                    } else {
                        status.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        bayiService.resimYukle(imgname, data).then((response) => {
                            if (response.status === 200) {
                                var item = {
                                    name: response.data[2].file,
                                    url: bayiService.imageUrlKucuk + response.data[2].file
                                }
                            } else {
                                status.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.bayiForm.bayiAdi) {
                        var imgname = randomText(13) + '-' +linkTemizle(this.bayiForm.bayiAdi)+".png";
                    } else {
                        imgname = randomText(13) + '-' +linkTemizle(file.name.split('.')[0])+".png";
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                        } else {
                            status.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    fileList.pop();
                    status.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            bayiTanimlama(formName, durum) {
                let self = this;
                this.bayiForm.resim = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.bayiForm.resim.push(e.name);
                        });
                        bayiService.bayiTanimlama(this.bayiForm.bayiAdi, this.bayiForm.telefon, this.bayiForm.adres, this.bayiForm.harita, this.bayiForm.webSite, this.bayiForm.resim, durum).then((response) => {
                            if (response.status === 200) {
                                if (durum === '0') {
                                    status.Status('success', this, 'Bayi arşive kaldırıldı.');
                                } else {
                                    status.Status('success', this, 'Bayi başarıyla eklendi.');
                                }
                                this.resetForm(formName);
                                this.bayiForm.ustBayiKodu = '';
                            } else if (response.status === 230) {
                                status.Status('warning', this, 'Bu bilgiler ile kayıtlı bir bayi zaten mevcut');

                            } else {
                                status.Status(response.status, this);
                            }
                        })
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.bayiForm.bayiTuru = '0';
                this.visibleUstBayi = false;
                this.bayiForm.link = null;
                this.linkVisible = false;
            },
        }

    }

    function linkTemizle(text)
    {
        var trMap = {
            'çÇ':'c',
            'ğĞ':'g',
            'şŞ':'s',
            'üÜ':'u',
            'ıİ':'i',
            'öÖ':'o'
        };
        for(var key in trMap) {
            text = text.replace(new RegExp('['+key+']','g'), trMap[key]);
        }
        return  text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }


</script>

<style scoped>

    #affix-container.haberTanim {
        position: relative;
        padding-left: 55px;
        left: -30px;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }

    .yanForm .card {
        margin-top: 10px;
    }
</style>